import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { OsUpdateStatesEffects } from './os-update-states.effects';
import { OsUpdateStatesReducer, MdmOsUpdateStatesFeatureKey } from './os-update-states.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(MdmOsUpdateStatesFeatureKey, OsUpdateStatesReducer),
    EffectsModule.forFeature([OsUpdateStatesEffects]),
  ],
  providers: [],
})
export class OsUpdateStatesStoreModule {}
